const moment = require('moment-timezone')

const WEEKDAYS = [
  { key: 'sunday', label: 'Sunday' },
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' }
]

const DEFAULT_TIME_INTERVAL = {
  start: '09:00',
  end: '17:00',
  duration_in_minutes: 480,
  cross_boundary: false
}

const DAY_MINUTES = 24 * 60

function clone(value) {
  return JSON.parse(JSON.stringify(value))
}

function createWeekdays(value = {}) {
  return WEEKDAYS.reduce((result, day) => {
    result[day.key] = Array.isArray(value[day.key]) ? clone(value[day.key]) : []
    return result
  }, {})
}

function createInterval(value = {}) {
  const interval = value ?? {}

  return {
    start_date: interval.start_date ?? moment().utc().toISOString(),
    working_days_amount: interval.working_days_amount ?? 1,
    rest_days_amount: interval.rest_days_amount ?? 1,
    cross_boundary: Boolean(interval.cross_boundary),
    time_intervals: Array.isArray(interval.time_intervals)
      ? clone(interval.time_intervals)
      : [clone(DEFAULT_TIME_INTERVAL)]
  }
}

function normalizeSection(value = {}) {
  const section = value ?? {}

  return {
    weekdays: createWeekdays(section.weekdays),
    interval: section.interval ? clone(section.interval) : null,
    selected_type:
      section.selected_type === 'interval' || section.selected_type === 'weekdays' ? section.selected_type : 'weekdays'
  }
}

function normalizeSchedule(value = {}) {
  const schedule = value ?? {}

  return {
    availability: normalizeSection(schedule.availability),
    regular_schedule: normalizeSection(schedule.regular_schedule)
  }
}

function sanitizeInterval(interval) {
  if (!interval) {
    return null
  }

  return {
    ...clone(interval),
    time_intervals: Array.isArray(interval.time_intervals) ? clone(interval.time_intervals) : []
  }
}

function sanitizeSection(section) {
  const normalized = normalizeSection(section)
  const result = {
    weekdays: createWeekdays(normalized.weekdays),
    selected_type: normalized.selected_type
  }

  if (normalized.interval || normalized.selected_type === 'interval') {
    result.interval = sanitizeInterval(normalized.interval)
  }

  return result
}

function timeToMinutes(value) {
  if (!value || typeof value !== 'string') {
    return 0
  }

  const [hours, minutes] = value.split(':').map(item => Number(item))
  return hours * 60 + minutes
}

function buildInterval(start, end, crossBoundary) {
  const startMinutes = timeToMinutes(start)
  const endMinutes = timeToMinutes(end)
  const duration = endMinutes >= startMinutes ? endMinutes - startMinutes : endMinutes + DAY_MINUTES - startMinutes

  return {
    start,
    end,
    duration_in_minutes: duration,
    cross_boundary: Boolean(crossBoundary)
  }
}

module.exports = {
  DAY_MINUTES,
  DEFAULT_TIME_INTERVAL,
  WEEKDAYS,
  buildInterval,
  clone,
  createInterval,
  createWeekdays,
  normalizeSchedule,
  normalizeSection,
  sanitizeSection,
  timeToMinutes
}
